import { render, staticRenderFns } from "./cell-organization-name.vue?vue&type=template&id=59bf675e&scoped=true"
import script from "./cell-organization-name.ts?vue&type=script&lang=ts&external"
export * from "./cell-organization-name.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-organization-name.vue?vue&type=style&index=0&id=59bf675e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf675e",
  null
  
)

export default component.exports